export function parseQuery(queryString) {
  const query = {};
  if (!queryString) return query;
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i += 1) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

export function findByClassName(className) {
  return document.getElementsByClassName(className)[0];
}
export function findMain() {
  return findByClassName('location main');
}
export function findLoadingIcon() {
  return findByClassName('location lds-ripple');
}
export function hideLoadingIcon() {
  findLoadingIcon().setAttribute('style', 'opacity: 0');
}
export function showLoadingIcon() {
  findLoadingIcon().setAttribute('style', 'opacity: 1');
}
export function hideMain() {
  findMain().setAttribute('style', 'opacity: 0');
}
export function showMain() {
  findMain().setAttribute('style', 'opacity: 1');
}
export function setMain(html) {
  findMain().innerHTML = html;
}
export function setMainAndScrollToTop(html) {
  setMain(html);
  window.scrollTo(0, 0);
}
